export default "/institutions/chime.svg";